import React from 'react'
import css from './WelcomeUmow.module.css'

const WelcomeUmow = () => {
	return (
		<section className={css.welcomeSection}>
			<div className={css.welcomeContainer}>
				<p className={css.welcomeText}>KALENDAR</p>
			</div>
		</section>
	)
}

export default WelcomeUmow
